import { render, staticRenderFns } from "./PurchaseDeliveryList.vue?vue&type=template&id=499fa961"
import script from "./PurchaseDeliveryList.vue?vue&type=script&lang=js"
export * from "./PurchaseDeliveryList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDeliveryList.vue?vue&type=style&index=0&id=499fa961&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports